var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import { invokeOrUndefined, rowIsValid } from '../../../utils';
import TreeLookup from 'src/components/LookupDialogs/TreeLookup/TreeLookup.vue';
import MainLookupDialog from '../../LookupDialogs/MainLookupDialog.vue';
import getDisplayValue from '../utils/getDisplayValue';
import { encrypt } from '../../../utils/encryption/encrypt';
import openValueSelectorDialog from '../utils/openValueSelectorDialog';
import createRecords from '../../../utils/entityOperations/createRecords';
import updateRecords from 'src/utils/entityOperations/updateRecords';
import Card from 'src/components/Card/Card';
import DisplayFormatSelector from 'src/components/DisplayFormatSelector/DisplayFormatSelector.vue';
import Form from 'src/components/Form/Form';
import getCurrentMode from 'src/utils/currentMode/getCurrentMode';
import { goToPreviousMode } from 'src/store/mode';
import { isEqual } from 'lodash';
import setCurrentRecord from 'src/utils/entityOperations/setCurrentRecord';
import getEntityDefaultRecordCardComponent from 'src/utils/entityOperations/propertyGetters/getEntityDefaultRecordCardComponent';
import Store from 'src/store';
import getColumns from 'src/utils/entityOperations/columns/getColumns';
export default Vue.extend({
    name: 'RecordCard',
    components: { TreeLookup, MainLookupDialog, Card, DisplayFormatSelector, Form },
    props: {
        cardProps: { type: Object, default: () => ({ showCloseButtonInUpperRightCornerProp: true }) },
        modeProp: { type: String, default: 'createRecord' },
        // pass either this pair ...
        idProp: { type: Number },
        localEntityNameProp: { type: String, default: null },
        // .. or, this pair
        recordProp: { type: Object, default: null },
        columnsProp: { type: Array, default: null },
        ctx: { type: Object, default: () => ({}) },
        title: { type: String },
        doNotGoToPreviousMode: { type: Boolean },
        doNotUnsetCurrentRecordOnCancel: { type: Boolean },
        preferredComponentVersionProp: { type: String, default: 'v2' },
        //
        executeAfterRecordWasCreated: { type: Function }
    },
    data() {
        return {
            formData: {},
            initialFormData: {},
            placeholderComponent: undefined,
            placeholderComponentProps: undefined,
            activeEntryUiVersion: 'v2'
        };
    },
    computed: {
        vm() { return this; },
        currentMode() { return getCurrentMode(); },
        EntityDefaultRecordCardComponent() {
            return getEntityDefaultRecordCardComponent(this.localEntityName);
        },
        entityDefaultRecordCardComponentProps() {
            return Object.assign({}, this.$props);
        },
        initialFormDataIsDifferentFromCurrentFormData() {
            return !isEqual(this.formData, this.initialFormData);
        },
        filtersToFeedToMainLookupDialog() {
            return Object.assign(Object.assign({}, this.currentMode.filters), this.ctx.localFilterModel);
        },
        formV2Props() {
            return {
                entityProp: this.localEntityName,
                modeProp: this.modeProp,
                value: this.formData,
                columnsProp: this.columns
            };
        },
        localEntityName() {
            let moduleName;
            if (this.localEntityNameProp) {
                moduleName = this.localEntityNameProp;
            }
            else if (this.currentMode) {
                if (this.currentMode.localEntityName)
                    moduleName = this.currentMode.localEntityName;
                if (this.currentMode.componentProps)
                    moduleName = this.currentMode.componentProps.localEntityNameProp;
            }
            return moduleName;
        },
        columns() {
            let cols = this.columnsProp || getColumns(this.localEntityName);
            cols = cols.filter(r => r.name !== 'row_menu');
            cols = cols.filter(r => !(this.modeProp === 'createRecord' && (r.hideWhenCreating || r.hideWhenCreatingAndEditing)));
            cols = cols.filter(r => !(this.modeProp === 'editRecord' && (r.hideWhenEditing || r.hideWhenCreatingAndEditing)));
            if (this.modeProp === 'editRecord' && cols && cols.find(r => r.name === 'id')) {
                const idCol = cols.find(r => r.name === 'id');
                if (idCol)
                    Vue.set(idCol, 'disabled', true);
            }
            if (this.currentMode.onlyShowTheseColumns)
                cols = cols.filter(col => { var _a, _b; return (_b = (_a = this.currentMode) === null || _a === void 0 ? void 0 : _a.onlyShowTheseColumns) === null || _b === void 0 ? void 0 : _b.includes(col.name); });
            return cols;
        },
        entityDisplayName() { return ((Store === null || Store === void 0 ? void 0 : Store.state[this.localEntityName]) || {}).entityDisplayName; },
        uniqueConstraints() { return Store === null || Store === void 0 ? void 0 : Store.getters[this.localEntityName + '/uniqueConstraints']; },
        createNewRecordTitle() { return this.currentMode.createNewRecordTitle || (Store === null || Store === void 0 ? void 0 : Store.getters[this.localEntityName + '/createNewRecordTitle']); },
        rowValidationRules() { return Store === null || Store === void 0 ? void 0 : Store.getters[this.localEntityName + '/rowValidationRules']; },
        computedTitle() {
            if (this.title)
                return this.title;
            if (this.modeProp === 'editRecord')
                return 'Edit record';
            if (this.modeProp === 'viewRecord')
                return 'View record';
            if (this.createNewRecordTitle)
                return this.createNewRecordTitle;
            if (this.entityDisplayName)
                return `Create new ${this.entityDisplayName} record`;
            return 'Create new record';
        }
    },
    watch: {
        preferredComponentVersionProp: {
            immediate: true,
            handler(newVal) { if (newVal)
                this.activeEntryUiVersion = newVal; }
        },
        recordProp: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.formData = Object.assign({}, newVal);
                    if (!this.initialFormData)
                        this.initialFormData = Object.assign({}, newVal);
                }
            }
        }
    },
    mounted() {
        this.initialize();
    },
    methods: {
        getDisplayValue,
        handleQInputFocus(e, col) {
            // @ts-ignore
            e.target.select();
            this.cellClickHandler(e, { row: this.formData, col }, /* valueChangeCallback: */ this.handleCellChange, this);
        },
        qInputRules(col) {
            return [
                (val) => (!col.required || (val !== undefined && val !== null && val !== '<empty>' && String(val).length > 0)) || 'This field is required'
            ];
        },
        setFormData(data) {
            this.formData = data;
        },
        showPopupProxy(col) {
            const els = this.$refs['qDateProxy' + col.field];
            const el = (els === null || els === void 0 ? void 0 : els[0]) || {};
            if (el.show)
                el.show();
        },
        hidePopupProxy(col) {
            const els = this.$refs['qDateProxy' + col.field];
            const el = (els === null || els === void 0 ? void 0 : els[0]) || {};
            if (el.hide)
                el.hide();
        },
        showThisColumnBeShown(cellProps) {
            const { col } = cellProps;
            if (typeof col.cellContentIsShown === 'function' && !col.cellContentIsShown(cellProps))
                return false;
            if (typeof col.cellContentIsHidden === 'function' && col.cellContentIsHidden(cellProps))
                return false;
            if (col.cellContentIsShown === true)
                return true;
            if (col.cellContentIsHidden === true)
                return false;
            return true;
        },
        handleCellChange(e, props) {
            const { row, col } = props;
            const field = col.sourceField ? col.sourceField(props) : col.field;
            const oldVal = String(row[field] || '');
            let newVal = '';
            newVal = (e && e.srcElement) ? String(e.srcElement.value) : e;
            const formatAsPercent = col.isPercent || (col.cellIsPercent && col.cellIsPercent({ row, col }));
            if (oldVal === newVal)
                return false;
            if (String(newVal).endsWith('%') && (col.isNumeric || formatAsPercent)) {
                newVal = String(parseFloat(newVal.substring(0, newVal.length - 1)) / 100);
            }
            else if (parseFloat(newVal) > 1 && formatAsPercent) {
                newVal = String(parseFloat(newVal) / 100);
            }
            else if (col.isNumeric) {
                newVal = String(parseFloat(newVal));
            }
            // validation
            const currentRow = row;
            const projectedRow = Object.assign({}, currentRow);
            projectedRow[field] = newVal;
            if (!rowIsValid(projectedRow, this.rowValidationRules, this))
                return false;
            Vue.set(this.formData, field, newVal);
        },
        cellClickHandler(e, cellProps, valueChangeCallback, ctx) {
            const { col, row } = cellProps;
            if (col.references || col.complexlyReferences || (col.cellReferences && col.cellReferences({ row: this.formData, col }))) {
                e.stopPropagation();
            }
            // trying opening value selector dialog. why code organized this way is unclear. legacy
            openValueSelectorDialog(cellProps, valueChangeCallback, ctx);
            if (col.isDisplayFormatSelector) {
                this.placeholderComponent = DisplayFormatSelector;
                const params = {
                    value: row[col.field],
                    callBackForSaving: (val) => valueChangeCallback(val, cellProps),
                    title: col.label
                };
                this.$nextTick(() => {
                    // @ts-ignore
                    const component = this.$refs['placeholderComponent'];
                    // @ts-ignore
                    component.openDialog(params);
                });
            }
        },
        submit() {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                const payload = this.formData; // the reason why we don't right away constraint payload to columns.map(field) is because for some entities there are columns that are calculated columns, and don't have data source columns in them.
                // Add fields that are in columns but not in formData
                // AND encrypt if needed
                this.columns.forEach((col) => {
                    const field = col.field;
                    if (payload[field] === undefined)
                        payload[field] = null;
                    if (col.required && col.isNumeric && payload[field] === null)
                        payload[field] = '0';
                    if (col.encrypted)
                        payload[field] = encrypt(payload[field] || '');
                });
                // Mix in filter values for fields that were not reflected in displayed columns (e.g., because sometimes we don't want to show all columns that we will be sending -- e.g., see mark20200407 in another file)
                Object.keys(this.currentMode.filters || {}).filter(field => !this.columns.map(col => col.field).includes(field)).forEach(field => {
                    payload[field] = this.currentMode.filters[field];
                });
                if (!rowIsValid(payload, this.rowValidationRules, this))
                    return false;
                let response;
                if (this.modeProp === 'createRecord') {
                    response = (yield createRecords(this.localEntityName, [payload])) || {};
                }
                else if (this.modeProp === 'editRecord') {
                    const formDataDiff = { id: this.formData.id };
                    for (const key in this.formData) {
                        if (((_a = this.initialFormData) === null || _a === void 0 ? void 0 : _a[key]) !== this.formData[key] || key === 'id') {
                            Vue.set(formDataDiff, key, this.formData[key]);
                        }
                    }
                    response = (yield updateRecords(this.localEntityName, [formDataDiff])) || {};
                }
                if (response) {
                    const newRecord = (_b = response.data) === null || _b === void 0 ? void 0 : _b[0];
                    if (this.modeProp === 'createRecord' && newRecord) {
                        invokeOrUndefined(this.executeAfterRecordWasCreated, newRecord);
                        this.$emit('create-new-record', newRecord);
                    }
                    else if (this.modeProp === 'editRecord') {
                        this.$emit('update-record', newRecord);
                    }
                    this.$emit('close');
                    if (!this.doNotGoToPreviousMode)
                        goToPreviousMode();
                    this.initialFormData = null;
                    this.$destroy();
                }
            });
        },
        cancel() {
            this.$emit('cancel');
            this.$emit('close');
            if (!this.doNotUnsetCurrentRecordOnCancel)
                setCurrentRecord(this.localEntityName, undefined);
            this.$destroy();
            if (!this.doNotGoToPreviousMode)
                goToPreviousMode();
        },
        close() {
            this.cancel();
        },
        initialize() {
            Vue.nextTick(() => {
                // handle potential autofocus when creating
                const afField = (this.columns.find(r => r.autofocusWhenCreating || this.currentMode.columnToAutofocusWhenCreating === r.name) || {}).field;
                if (afField) {
                    // @ts-ignore
                    const inputEl = this.$refs['input_' + afField][0];
                    inputEl.focus();
                }
            });
            if (['editRecord', 'viewRecord'].includes(this.modeProp)) {
                const record = Store.state[this.localEntityName].list.find((r) => r.id === this.idProp);
                Vue.set(this, 'formData', record);
            }
            else if (this.modeProp === 'createRecord') {
                Vue.set(this, 'formData', this.recordProp || {});
                this.columns.forEach(col => {
                    let val;
                    if (this.currentMode.filters && this.currentMode.filters[col.field] !== undefined) {
                        val = this.currentMode.filters[col.field];
                    }
                    else if (col.defaultValueWhenCreating !== undefined) {
                        if (typeof col.defaultValueWhenCreating === 'function') {
                            val = col.defaultValueWhenCreating();
                        }
                        else {
                            val = col.defaultValueWhenCreating;
                        }
                    }
                    else {
                        val = null;
                    }
                    Vue.set(this.formData, col.field, val);
                });
            }
            Vue.set(this, 'initialFormData', this.formData);
        }
    }
});
